module.exports = __webpack_public_path__ + "static/media/video5.607c46a2.m4v";